import { render, staticRenderFns } from "./cancelEncasement.vue?vue&type=template&id=6c31b896&scoped=true&"
import script from "./cancelEncasement.vue?vue&type=script&lang=js&"
export * from "./cancelEncasement.vue?vue&type=script&lang=js&"
import style0 from "./cancelEncasement.vue?vue&type=style&index=0&id=6c31b896&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c31b896",
  null
  
)

export default component.exports